import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import * as moment from "moment";
import { Device } from "../../../models/device";
import { PrecipitationConverter } from "../../../converters/precipitation-value";
import { MeasurementSystems } from "../../../converters/measurement-systems";
import { I18N } from "aurelia-i18n"

@autoinject
export class MilesiteWTS506WeatherStationChart extends BaseDeviceChart {

	constructor(api: Api, private i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
			this.isAttached = true;
		},
			100);
	}

	calculatePrecipitation(value: number): number {

		let measurementSystem = localStorage.getItem("measurement-system");
		if (!measurementSystem) {
			measurementSystem = MeasurementSystems.imperial;
		}

		switch (measurementSystem) {
			case MeasurementSystems.metric:
				return PrecipitationConverter.toMetric(value);
			case MeasurementSystems.imperial:
				return PrecipitationConverter.toImperial(value);
			default:
				return PrecipitationConverter.toImperial(value);
		}
	}

	/*
	{
    "protocolVersion": 2,
    "deviceId": 5275,
    "solarRadiation": 472,
    "precipitation": 0,
    "lightningStrikeCount": 0,
    "lightningAverageDistance": 0,
    "windSpeed": 0.85,
    "windDirection": 214,
    "maximumWindSpeed": 2.19,
    "airTemperature": 30.8,
    "vaporPressure": 1.78,
    "atmosphericPressure": 100.57,
    "relativeHumidity": 41.1,
    "sensorTemperatureInternal": 35.4,
    "xOrientationAngle": -0.1,
    "yOrientationAngle": 1.4,
    "compassHeading": 0,
    "northWindSpeed": -0.7,
    "eastWindSpeed": -0.47,
    "battery": 2668,
    "timestamp": "2020-10-06T15:08:05",
    "rssi": -39
}
	 */

	protected processData(measurements: MeasurementViewModel[]) {
		if (measurements.length > 0) {
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[1].data = [];
			measurements.forEach((item: MeasurementViewModel) => {
				this.chartData.labels.push(moment(item.data.timestamp));
				//this.chartData.labels.push(moment(item.data.timestamp).format("YY-MM-DD hh:mm a"));
				this.chartData.datasets[0].data.push(this.calculatePrecipitation(item.data.rainfallTotal));
				this.chartData.datasets[1].data.push(this.convertTemperature(item.data.temperature)); //air-temperature
			});
			this.chart.refreshChart();
		}
	}

	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			datasets: [
				{
					type: "bar",
					label: "Precipitation",
					barThickness: "flex",
					backgroundColor: "rgba(0,0,255,0.2)",
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(220,220,220,1)",
					yAxisID: "Precipitation",
					data: []
				},
				{
					type: "line",
					label: `Temperature (${this.getTemperatureSymbol()})`,
					backgroundColor: "rgba(220,220,220,0.2)",
					borderColor: "rgba(220,220,220,1)",
					pointColor: "rgba(220,220,220,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(151,187,205,1)",
					yAxisID: "Temperature",
					data: []
				}
			]
		};
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				//xAxes: [{
				//	type: 'time',
				//	distribution: 'series',
				//	offset: true,
				//	ticks: {
				//		major: {
				//			enabled: true,
				//			fontStyle: 'bold'
				//		},
				//		source: 'data',
				//		autoSkip: true,
				//		autoSkipPadding: 75,
				//		maxRotation: 0,
				//		sampleSize: 100
				//	},
				//	afterBuildTicks(scale, ticks) {
				//		const majorUnit = scale._majorUnit;
				//		const firstTick = ticks[0];
				//		var i, ilen, val, tick, currMajor, lastMajor;

				//		val = moment(ticks[0].value);
				//		if ((majorUnit === 'minute' && val.second() === 0)
				//			|| (majorUnit === 'hour' && val.minute() === 0)
				//			|| (majorUnit === 'day' && val.hour() === 9)
				//			|| (majorUnit === 'month' && val.date() <= 3 && val.isoWeekday() === 1)
				//			|| (majorUnit === 'year' && val.month() === 0)) {
				//			firstTick.major = true;
				//		} else {
				//			firstTick.major = false;
				//		}
				//		lastMajor = val.get(majorUnit);

				//		for (i = 1, ilen = ticks.length; i < ilen; i++) {
				//			tick = ticks[i];
				//			val = moment(tick.value);
				//			currMajor = val.get(majorUnit);
				//			tick.major = currMajor !== lastMajor;
				//			lastMajor = currMajor;
				//		}
				//		return ticks;
				//	}
				//}],
				//xAxes: [{
				//	type: 'time',
				//	distribution: 'series'
				//}],
				//xAxes: [
				//	{
				//		display: true,
				//		scaleLabel: {
				//			display: true,
				//			labelString: "Timestamp"
				//		}
				//	}
				//],
				xAxes: [{
					type: "time",
					time: {
						//format: "MM/DD/YYYY HH:mm"
						unit: "day"
					}
				}],
				yAxes: [
					{
						id: "Temperature",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Temperature"
						},
						position: "right"
					},
					{
						id: "Precipitation",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Precipitation"
						},
						position: "left"
					}
				]
			}
		};
	}

}

